import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingService } from '../../loading/loading.service';

import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { PopoverController } from '@ionic/angular';
import { GroupPermissionsService } from 'src/app/modules/services/group-permissions/group-permissons.service';

@Component({
  selector: 'app-restrictions-popover',
  templateUrl: './restrictions-popover.component.html',
  styleUrls: ['./restrictions-popover.component.scss']
})
export class RestrictionsPopoverComponent implements OnInit {
  restrictions: any[] = [];
  @Input() currentRestrictions: any[] = [];
  form: FormGroup | undefined;

  constructor(
    private fb: FormBuilder,
    private loadingService: LoadingService,
    private groupPermissionsService: GroupPermissionsService,
    private toastService: ToastService,
    private popoverController: PopoverController
  ) { }

  ngOnInit() {
    this.loadGroupPermissions();
  }

  loadGroupPermissions() {
    this.loadingService.showLoading();
    this.groupPermissionsService.getRestricoes().subscribe(
      (response: any) => {
        this.loadingService.hideLoading();
        this.restrictions = response;
        this.initializeFormControls();
      },
      (error: any) => {
        this.loadingService.hideLoading();
      }
    );
  }

  initializeFormControls() {
    const formControls = this.restrictions.reduce((controls, restriction) => {
      const currentValue = this.currentRestrictions.some(r => r.id === restriction.id);
      controls[restriction.nome] = [currentValue, Validators.required];
      return controls;
    }, {});

    this.form = this.fb.group(formControls);
  }

  saveRestrictions() {
      if (!this.form || this.form.invalid) {
        this.toastService.showError('Formulário inválido. Por favor, verifique os campos.');
        return;
      }
    const restrictionsData = this.form.value;

    const transformedData = this.restrictions
      .filter(restriction => restrictionsData[restriction.nome])
      .map(restriction => ({ id: restriction.id }));
    this.popoverController.dismiss(transformedData);
  }

  sanitizeControlName(name: string): string {
    return name
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }
}

